import {Model} from "miragejs"
import {ApplicationSerializer} from "@zhoujianhui/ultra-miragejs"

const advertisement = {
    models: {
        advertisement: Model
    },

    serializers: {
        advertisement: ApplicationSerializer
    },

    fixtures: {
        advertisements: [
            {
                title: "广告一",
                url: "广告一"
            },
            {
                title: "广告二",
                url: "广告二"
            }
        ]
    },

    routes() {
        //TODO 设计广告API
        this.get("/advertisements", function (schema) {
            return schema.advertisements.all()
        })
    }
}

export default advertisement